export default __webpack_public_path__ + "static/media/photo--sm--wheel-2.c8bb5686.jpg";